jQuery(document).ready(function ($) {
	// Open
	$("[data-popup-trigger]").on("click", function () {
		const target = $(this).attr("data-popup-trigger");
		$(`[data-popup-name=${target}]`).addClass("is-visible");
		$("body").addClass("POPUP-lock-body");
	});

	$(".POPUP").on("click", function (event) {
		if (
			$(event.target).hasClass("POPUP") ||
			$(event.target).hasClass("POPUP__close")
		) {
			$(this).removeClass("is-visible");
			$("body").removeClass("POPUP-lock-body");
		}
	});
});
